export default __webpack_public_path__ + "static/media/fan.c4a7d053.ogg";